// Money is INTEGER CENTS everywhere. Format only at the display boundary.

const usd = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
})

export function formatCents(cents: number): string {
  return usd.format(cents / 100)
}

// Parse a user-typed dollar amount ("$150", "150.5", "1,200") -> cents, or null.
export function parseDollarsToCents(input: string): number | null {
  const raw = input.trim().replace(/[$,\s]/g, '')
  if (raw === '') return 0
  if (!/^\d*\.?\d+$/.test(raw)) return null
  return Math.round(Number(raw) * 100)
}

// Extended amount for a line, computed from canonical minutes and cents/hour.
// Rounded to whole cents at the line level so column sums stay exact.
export function lineAmountCents(minutes: number, rateCents: number): number {
  return Math.round((minutes * rateCents) / 60)
}

// tax_rate_bp is basis points (e.g. 875 = 8.75%). Applied to the subtotal.
export function taxCents(subtotalCents: number, taxRateBp: number): number {
  return Math.round((subtotalCents * taxRateBp) / 10000)
}
